import { render, staticRenderFns } from "./HandleFileContact.vue?vue&type=template&id=893a5d80&scoped=true"
import script from "./HandleFileContact.vue?vue&type=script&lang=js"
export * from "./HandleFileContact.vue?vue&type=script&lang=js"
import style0 from "./HandleFileContact.vue?vue&type=style&index=0&id=893a5d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a5d80",
  null
  
)

export default component.exports